export default function Pagination({
  current,
  total,
  onChange,
}: {
  current: number;
  total: number;
  onChange: (page: number) => void;
}) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10 flex-wrap" aria-label="分页">
      <button
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-label transition-colors cursor-pointer ${
            p === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-300"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}